export default __webpack_public_path__ + "static/member6-1db5faf9c6d8fd19e7d819e934fd8ae3.jpg";